// extracted by mini-css-extract-plugin
module.exports = {"SmallContainer":"Skill_SmallContainer__3SjP5"};